import React from 'react'
import { styled } from '@mui/material/styles'
import { FormControlLabel, RadioGroup } from '@mui/material'
import Radio from '../Radio/Radio'
import ThemeConfig from '../../theme/ThemeConfig'
import { GroupType, getGroupType } from './types/GroupType'
import { AlertType } from './types/AlertType'
import { HeaderProps } from './Header'

const PREFIX = 'AlertGroupings'

const classes = {
  container: `${PREFIX}-container`,
}

const Root = styled('div', {
  shouldForwardProp: prop => prop !== 'alertType',
})<HeaderProps>(({ alertType }) => ({
  [`&.${classes.container}`]: {
    padding: '0 8px',
    backgroundColor:
      alertType === AlertType.Warning
        ? ThemeConfig.palette.warning.light
        : ThemeConfig.palette.error.light,
    minHeight: '32px',
    maxHeight: '32px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-around',
  },
}))

export interface AlertGroupingProps {
  alertType: AlertType
  grouping: GroupType
  onChange: (value: GroupType) => void
}

const AlertGroupings = ({
  alertType,
  grouping,
  onChange,
}: AlertGroupingProps) => {
  const handleOnChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = getGroupType(event.target.value)
    if (value !== grouping) {
      onChange?.(value)
    }
  }

  return (
    <Root className={classes.container} alertType={alertType}>
      <label htmlFor="groupBy">Group By:</label>
      <RadioGroup
        aria-label="Group By"
        value={grouping}
        name="groupBy"
        row
        onChange={handleOnChange}
      >
        <FormControlLabel
          control={<Radio color="secondary" />}
          label="Product"
          value={GroupType.Product}
        />
        <FormControlLabel
          control={<Radio color="secondary" />}
          label={alertType === AlertType.Error ? 'Error' : 'Warning'}
          value={GroupType.FieldAndMessage}
        />
        <FormControlLabel
          control={<Radio color="secondary" />}
          label="None"
          value={GroupType.None}
        />
      </RadioGroup>
    </Root>
  )
}

export default AlertGroupings
